import { Formik, Form } from "formik";
import { observer } from "mobx-react-lite";
import { useState } from "react";
import { Modal } from "react-bootstrap";
import * as yup from "yup";
import GradientButton from "../Core/GradientButton";
import PinCodeBoxes from "../Core/PinCodeBoxes";
import { useSessionStore } from "../../Stores/SessionStore";
import { customerMustSetOwnPin } from "./customerPinAuth";

const validationSchema = yup
	.object({
		NewPin: yup.string().required("PIN is required.").matches(/^\d{4}$/, "PIN must be exactly 4 digits."),
		ConfirmNewPin: yup
			.string()
			.required("Please confirm your PIN.")
			.oneOf([yup.ref("NewPin")], "PIN confirmation should match."),
	})
	.required();

const SetPinModal = observer(function SetPinModal() {
	const store = useSessionStore();
	const [saving, setSaving] = useState(false);
	const [error, setError] = useState(null);

	const customer = store.CustomerDetails?.Customer;
	const visible = customerMustSetOwnPin(customer);

	if (!visible) return null;

	async function handleSubmit(values) {
		if (!customer) return;

		setError(null);
		setSaving(true);
		const result = await store.CustomersService.UpdateProfile({
			CellphoneNumber: customer.CellphoneNumber,
			Email: customer.Email,
			Language: customer.LanguagePreference,
			CommunicationPreference: customer.EmailPreference,
			NewPin: values.NewPin,
			NewPinConfirm: values.ConfirmNewPin,
		});
		setSaving(false);

		if (result?.Success) {
			await store.LoadCustomerDetails();
			return;
		}

		setError(result?.Message ?? "Failed to set your PIN. Please try again.");
	}

	return (
		<Formik initialValues={{ NewPin: "", ConfirmNewPin: "" }} validationSchema={validationSchema} onSubmit={handleSubmit}>
			{({ handleSubmit: submit, values, setFieldValue, errors, touched }) => (
				<Modal show={visible} backdrop="static" keyboard={false} size="lg">
					<Modal.Header>
						<h3>Create Your PIN</h3>
					</Modal.Header>
					<Modal.Body>
						<p className="text-center mb-4">Please create a 4-digit PIN for quicker sign-in next time.</p>
						<Form>
							<div className="mb-4">
								<label className="form-label mb-3">New PIN</label>
								<PinCodeBoxes value={values.NewPin} onChange={(value) => setFieldValue("NewPin", value)} />
								<small className="text-danger">{touched.NewPin && errors.NewPin}</small>
							</div>
							<div className="mb-4">
								<label className="form-label mb-3">Confirm PIN</label>
								<PinCodeBoxes value={values.ConfirmNewPin} onChange={(value) => setFieldValue("ConfirmNewPin", value)} />
								<small className="text-danger">{touched.ConfirmNewPin && errors.ConfirmNewPin}</small>
							</div>
							{error && <small className="text-danger d-block mb-3">{error}</small>}
							<GradientButton
								title={saving ? "Saving..." : "Set PIN"}
								variant="greenYellow"
								onClick={() => submit()}
								disabled={saving}
								loading={saving}
							/>
						</Form>
					</Modal.Body>
				</Modal>
			)}
		</Formik>
	);
});

export default SetPinModal;
